import React, { useState, useEffect } from "react";

function useForm(item = "") {
  const [value, setValue] = useState(item);
  const [error, setError] = useState(false);
  const [errorMsg, setErrorMsg] = useState("");

  const onChange = (e) => {
    setValue(e.target.value);
  };

  const onFocus = (e) => {
    setError(false);
    setErrorMsg("");
  };

  useEffect(() => {
    setValue(item);
  }, []);

  const onDateChange = (text) => {
    console.log(text);
    setValue(text);
  };

  return {
    value,
    error,
    errorMsg,
    onChange,
    setError,
    setValue,
    setErrorMsg,
    onDateChange,
    onFocus
  };
}

export default useForm;
